export const filterObjectByFields = (fields, data) => {
  const filteredObject = Object.keys(data)
    .filter(key => fields.includes(key))
    .reduce((obj, key) => {
      obj[key] = data[key]
      return obj
    }, {})

  return filteredObject
}

export const queryBuilder = (
  pageNum,
  pageSize,
  sortBy,
  sortOrder,
  filters,
  startDate,
  endDate,
  searchString
) => {
  const filterString = createFilterString(filters)

  if (filterString.length > 0) {
    const query = `pageNum=${pageNum}&pageSize=${pageSize}&sortBy=${sortBy}&sortOrder=${sortOrder}&${filterString}&fromDate=${
      startDate ? startDate.format('MM/DD/YYYY') : null
    }&toDate=${endDate ? endDate.format('MM/DD/YYYY') : null}&searchString=${
      searchString ? searchString : null
    }`
    return query
  } else {
    const query = `pageNum=${pageNum}&pageSize=${pageSize}&sortBy=${sortBy}&sortOrder=${sortOrder}&fromDate=${
      startDate ? startDate.format('MM/DD/YYYY') : null
    }&toDate=${endDate ? endDate.format('MM/DD/YYYY') : null}&searchString=${
      searchString ? searchString : null
    }`
    return query
  }
}

const createFilterString = filters => {
  let filterString = ''

  filters.map(filterObj => {
    console.log('Filter obj: ', filterObj)

    for (let [key, value] of Object.entries(filterObj)) {
      value.map(val => {
        filterString += `${key}=${val}&`
      })
    }
  })

  if (filterString.charAt(filterString.length - 1) === '&') {
    filterString = filterString.substring(0, filterString.length - 1)
  }

  return filterString
}

const parameterizeArray = (key, array) => {
  console.log('Array', array)
  if (array.length === 0) {
    return
  }

  array = array.map(encodeURIComponent)
  return `&${key}[]=${array.join(`&${key}[]=`)}`
}




const getFolderPathRec = (parent, folderId) => {
    let path = '/'+parent.text;
    if ( parent._id === folderId ){
        return path;
    }
    if ( parent.children){
        let subpath;
        for ( const child of parent.children) {
            subpath = getFolderPathRec(child, folderId);
            if (subpath) {
                break;
            }
        }
        if (subpath) {
            return path + subpath;
        }
    }

}

export const getFolderPath = (treeData, folderId) => {
    const path = getFolderPathRec(treeData[0], folderId);
    return path;
}

export const findFolder = (folderId, data) => {
    let found;
    for (let folder of data) {
        if (folder._id == folderId) {
            found = folder;
            break;
        }
        else {
            if (folder.children) {
                found = findFolder(folderId, folder.children);
                if ( found ) break;
            }
        }
    }
    return found;
}


export const isAncestor = (srcfolderId, targetFolderId, treeData) => {
    const ancestor = findFolder(srcfolderId, treeData);
    const found = findFolder(targetFolderId, ancestor.children);
    return found;
}


export const formatFileSize =  (size) => {
    var i = -1;
    var byteUnits = [' KB', ' MB', ' GB', ' TB', 'PB', 'EB', 'ZB', 'YB'];
    do {
        size = size / 1024;
        i++;
    } while (size > 1024);

    return Math.max(size, 0.1).toFixed(1) + byteUnits[i];
}

export const formatNumber = (number)=>{
    if ( number ) {
        return number.toFixed(4);
    }
    return number;
}

export const sortTree = data => {
    data.sort(comparator)
    data.forEach(function(parent) {
        sortChildren(parent)
    })
}

export const sortChildren = parent => {
    var children = parent.children
    if (children) {
        children.sort(comparator)
        children.forEach(function(child) {
            sortChildren(child)
        })
    }
}

export const comparator = (a, b) => {
    if (a.text > b.text) {
        return 1
    }
    if (a.text < b.text) {
        return -1
    }
    // a must be equal to b
    return 0
}